module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "lxm-transition-fade",
      "mode": "out-in"
    }
  }, [(!this.hide && this.content) ? _c('div', [_c('div', {
    staticClass: "lxm-dashboard-reg-source-tip",
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "lxm-dashboard-reg-source-tip__close",
    on: {
      "click": _vm.onCloseClick
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('div', {
    staticClass: "lxm-dashboard-reg-source-tip__content",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3fe65216", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3fe65216!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Dashboard/components/RegSourceTip.vue
// module id = 841
// module chunks = 0